// Game configuration and rules
export const GAME_TYPES = {
  '8-Ball': {
    name: '8-Ball',
    balls: Array.from({ length: 15 }, (_, i) => i + 1),
    winningBall: 8,
    rules: {
      breakAndRun: true,
      ballInHand: true,
      threeFoulRule: false,
      pushOut: false,
      wildEight: false,
      callEight: true,
      eightOnBreak: false,
    },
    defaultSettings: {
      player1RaceTo: 7,
      player2RaceTo: 7,
      whoBreaks: 'winner',
      firstBreaker: 'player1',
      threeFoulRule: false,
      rackSetup: 'standard',
      controlMode: 'strict',
      gameMode: 'pvp',
      trackingMode: 'detailed',
    }
  },
  '9-Ball': {
    name: '9-Ball',
    balls: Array.from({ length: 9 }, (_, i) => i + 1),
    winningBall: 9,
    rules: {
      breakAndRun: true,
      ballInHand: true,
      threeFoulRule: true,
      pushOut: true,
      wildNine: true,
      callNine: true,
      nineOnBreak: true,
    },
    defaultSettings: {
      player1RaceTo: 7,
      player2RaceTo: 7,
      whoBreaks: 'winner',
      firstBreaker: 'player1',
      threeFoulRule: true,
      nineBallRule: 'wild',
      wildNineOnBreak: true,
      rackSetup: 'standard',
      controlMode: 'strict',
      gameMode: 'pvp',
      trackingMode: 'detailed',
    }
  },
  '10-Ball': {
    name: '10-Ball',
    balls: Array.from({ length: 10 }, (_, i) => i + 1),
    winningBall: 10,
    rules: {
      breakAndRun: true,
      ballInHand: true,
      threeFoulRule: true,
      pushOut: true,
      wildTen: false,
      callTen: true,
      tenOnBreak: false,
    },
    defaultSettings: {
      player1RaceTo: 7,
      player2RaceTo: 7,
      whoBreaks: 'winner',
      firstBreaker: 'player1',
      threeFoulRule: true,
      tenBallLast: false,
      rackSetup: 'standard',
      controlMode: 'strict',
      gameMode: 'pvp',
      trackingMode: 'detailed',
    }
  }
};

export const getGameConfig = (gameType) => {
  return GAME_TYPES[gameType] || GAME_TYPES['9-Ball'];
};

export const getAvailableBalls = (gameType) => {
  const config = getGameConfig(gameType);
  return config.balls;
};

export const isGameWinningBall = (ball, gameType) => {
  const config = getGameConfig(gameType);
  return ball === config.winningBall;
};

export const getWinningBall = (gameType) => {
  const config = getGameConfig(gameType);
  return config.winningBall;
};

export const getDefaultSettings = (gameType) => {
  const config = getGameConfig(gameType);
  return config.defaultSettings;
};

// Game-specific win condition logic
export const checkWinCondition = (gameType, shotData, matchData, isBreakShot, finalTags) => {
  const config = getGameConfig(gameType);
  const winningBall = config.winningBall;
  const gameBallMade = shotData.ballsMade.includes(winningBall);
  
  if (!gameBallMade) return { isWin: false, ballsToSpot: [] };
  
  let isWin = false;
  let ballsToSpot = [];
  
  switch (gameType) {
    case '8-Ball':
      // 8-ball rules: must call 8-ball to win
      if (isBreakShot) {
        // 8-ball made on break is a loss
        isWin = false;
        ballsToSpot.push(8);
      } else {
        // Must call 8-ball to win
        if (finalTags.includes('win')) {
          isWin = true;
        } else {
          ballsToSpot.push(8);
        }
      }
      break;
      
    case '9-Ball':
      if (isBreakShot) {
        // On break shot: only win if Wild 9 AND wildNineOnBreak is true
        if (matchData.nineBallRule === 'wild' && matchData.wildNineOnBreak) {
          isWin = true;
        } else {
          ballsToSpot.push(9);
        }
      } else {
        // Non-break shot: win if Wild 9, or if Call 9 and win tag is manually selected
        if (matchData.nineBallRule === 'wild') {
          isWin = true;
        } else if (matchData.nineBallRule === 'call' && finalTags.includes('win')) {
          isWin = true;
        } else {
          ballsToSpot.push(9);
        }
      }
      break;
      
    case '10-Ball':
      const isCalledWin = finalTags.includes('win');
      if (isCalledWin) {
        isWin = true;
      } else {
        ballsToSpot.push(10);
      }
      break;
      
    default:
      isWin = false;
      ballsToSpot.push(winningBall);
  }
  
  return { isWin, ballsToSpot };
};

// Check for special shots (golden break, etc.)
export const checkSpecialShots = (gameType, shotData, matchData, isBreakShot) => {
  const config = getGameConfig(gameType);
  const winningBall = config.winningBall;
  const specialTags = [];
  
  // Golden break detection
  if (isBreakShot && 
      gameType === '9-Ball' && 
      matchData.nineBallRule === 'wild' &&
      matchData.wildNineOnBreak && 
      shotData.ballsMade.includes(winningBall)) {
    specialTags.push('golden_break');
  }
  
  return specialTags;
};


